/* eslint-disable max-len */
import React, {ReactNode} from "react";
import {
    Stack,
} from "react-bootstrap";
import {CgClose} from "react-icons/cg";
import { BsCheckLg, BsExclamationTriangleFill } from "react-icons/bs";
import { FaCircleInfo } from "react-icons/fa6";

type AlertType = "info" | "success" | "error";
const alertTypeIcon:Record<AlertType, ReactNode> = {
    info: <FaCircleInfo className="infoMsg align-self-center flex-shrink-0" size={20} />,
    success: <BsCheckLg className="successMsg align-self-center flex-shrink-0" size={20} />,
    error: <BsExclamationTriangleFill size={16} className="errorImage align-self-center flex-shrink-0 m-0" />,
};

export type AlertProps = {
    message: string | ReactNode,
    type: AlertType,
    onClose:() => void,
    showClose?: boolean
};

const NotificationBanner: React.FC<AlertProps> = ({
    message,
    type,
    onClose,
    showClose = true,
}) => {
    const alertIcon = alertTypeIcon[type];
    return (
        <Stack direction="horizontal" gap={2} className={`w-100 ${type}Banner`}>
            <div className={`${type}BannerColoredBlock`} />
            <div className="d-flex justify-content-start mt-2 mb-2 gap-2 w-100">
                {alertIcon}
                    <div
                        className={`font-main align-self-center bannerTextCenter flex-grow-1 text-left ${type}Msg `}
                    >
                        {message}
                    </div>
                    {showClose && (
                        <CgClose
                            className="modalCloseBtn align-self-center flex-shrink-0"
                            tabIndex={0}
                            size={20}
                            style={{ marginLeft: "18px", marginRight: "10px" }}
                            onClick={onClose}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onClose();
                                }
                            }}
                        />
                    )}
            </div>
        </Stack>
    );
};
export default NotificationBanner;
